import { activity, quizard, wood } from "./assets/projects";

export const projects = [
  {
    id: 0,
    img: activity,
    name: "ActiviTapp",
    role: "Full Stack",
    sector: "Lifestyle",
    status: "Dead",
    type: "Individual",
    description: "An app you tap.. for activities!",
    github: "https://github.com/waddal/ActiviTapp",
    link: "https://activitapp.herokuapp.com/",
  },
  {
    id: 1,
    img: quizard,
    name: "Quizard",
    role: "Full Stack",
    sector: "Education",
    status: "Dead",
    type: "Individual",
    description: "A test of knowledge for software wizards~",
    github: "https://github.com/waddal/Quizard",
    link: "https://qquizard.herokuapp.com/",
  },
  {
    id: 2,
    img: wood,
    name: "Woodstock",
    role: "Frontend",
    sector: "Ecommerce",
    status: "Live",
    type: "Collaborative",
    description: "Lumber lovers online supply store",
    github: "https://github.com/waddal/ecommerce",
    link: "https://woodycommerce.netlify.app/",
  },
  {
    id: 3,
    img: activity,
    name: "ShipsAhoy",
    role: "Fullstack",
    sector: "Gaming",
    status: "Beta",
    type: "Individual",
    description: "Set sail into a sea of unknowns!",
    github: "https://github.com/waddal/ecommerce",
    link: "https://woodycommerce.netlify.app/",
  },
];
